import { Trans } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

export default function CommentReacted({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.ideaCommentReacted"
      values={{
        name: util.getEventNames(events ?? []),
        idea: ownerIdea?.name || "Deleted",
      }}
    />
  );
}
